import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

export interface TypeSelectorOption<T = any> {
  value: T;
  title: string;
  description: string;
  icon?: string;
}

@Component({
  selector: 'lib-type-selector',
  templateUrl: './type-selector.component.html',
  styleUrls: ['./type-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TypeSelectorComponent {
  @Input() options: TypeSelectorOption[] = [];
  @Input() header: string;
  @Input() selectedValue: any = null;
  @Input() submitLabel = 'Next';
  @Input() selectLabel = 'Select';
  @Input() selectedLabel = 'Selected';
  /** Set false when several selectors share one selection and the page owns the submit button. */
  @Input() showSubmit = true;

  @Output() selectionChange = new EventEmitter<any>();
  @Output() next = new EventEmitter<void>();

  select(value: any): void {
    this.selectedValue = value;
    this.selectionChange.emit(value);
  }

  get hasSelection(): boolean {
    return this.selectedValue !== null && this.selectedValue !== undefined;
  }
}
